<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Profile / Change Password</h1>
        </div>
        <div class="content-section">
            <div class="order-view  max-WT-700 mrgn-0-auto setting-page">
                <div class="admin-profile">
                    <h4 class="mb20 text-center">Change Password</h4>
                </div>
                <div class="add-store-block input-style mt-3">
                    <form [formGroup]="form" #f="ngForm">
                        <div class="form-group row align-items-baseline view-label-align">
                            <label class="col-md-5 textalignright ">Current Password <span>:</span></label>
                            <div class="col-md-7 textaligncenter">
                                <div class="form-group">
                                    <input type="password" class="form-control" placeholder="Current Password"
                                        formControlName="oldPassword" (keypress)="mainService.preventSpace($event)"
                                        maxlength="30">
                                    @if(form.get('oldPassword')?.invalid && (form.get('oldPassword')?.touched ||
                                    form.get('oldPassword')?.dirty)){
                                    <div class="text-danger">
                                        @if(form.get('oldPassword')?.hasError('required')){
                                        <small>*Please enter old password.</small>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline mt-3 view-label-align">
                            <label class="col-md-5 textalignright ">New Password <span>:</span></label>
                            <div class="col-md-7 textaligncenter">
                                <div class="form-group">
                                    <input type="password" class="form-control" placeholder="New Password"
                                        formControlName="newPassword" (keypress)="mainService.preventSpace($event)"
                                        maxlength="30">
                                    @if(form.get('newPassword')?.invalid && (form.get('newPassword')?.touched ||
                                    form.get('newPassword')?.dirty)){
                                    <div class="text-danger">
                                        @if(form.get('newPassword')?.hasError('required')){
                                        <small>*Please enter new password.</small>
                                        }
                                        @if(form.get('newPassword')?.hasError('pattern')){
                                        <small>
                                            *Password should have minimum 8 characters, at least 1 uppercase letter,
                                            1 lowercase letter, 1 number and 1 special character.</small>
                                        }

                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline mt-3 view-label-align">
                            <label class="col-md-5 textalignright ">Confirm New Password <span>:</span></label>
                            <div class="col-md-7 textaligncenter">
                                <div class="form-group">
                                    <input type="password" class="form-control" placeholder="Confirm New Password"
                                        formControlName="confirmPassword" (keypress)="mainService.preventSpace($event)"
                                        maxlength="30">
                                    @if(form.get('confirmPassword')?.dirty){
                                    <div class="text-danger">
                                        @if(form.get('confirmPassword')?.value != form.get('newPassword')?.value){
                                        <small>*Password mismatched.</small>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="text-center mt-3 mb-3">
                    <button class="btn btn-large  max-WT-150 btn-theme"
                        [disabled]="form.invalid || (form.get('confirmPassword')?.value != form.get('newPassword')?.value)"
                        (click)="changePasswordApi()">Save</button>
                    <button class="btn btn-large  max-WT-150 btn-theme" routerLink="/my-profile">Back</button>
                </div>
            </div>
        </div>
    </main>
</div>